import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 1em;

	img {
		width: 8em;
	}

	p {
		margin: 0;
		color: #fff;
		text-align: center;
		paint-order: stroke fill;
		filter: drop-shadow(0 0.108em 0 #000);
		-webkit-text-stroke-width: 0.108em;
		-webkit-text-stroke-color: #000;
		font-family: "Baloo";
		font-size: 1.25em;
		font-style: normal;
		font-weight: 400;
		line-height: 122%;
	}
`;
